import objwrap from "./helper/objwrap";

export default objwrap("background");
